// #region import
import React, { useState } from 'react';
import {
  MunicipalityCode,
  Municipality,
  City,
  Village,
} from '../../../models/municipality';
import {
  TITLE_TEXT,
  MESSAGE_TEXT,
  DEVICE_TYPE_TEXT,
  DEVICE_TYPE_ALL_TEXT,
  DEVICE_TYPE_ANDROID_TEXT,
  DEVICE_TYPE_IOS_TEXT,
  DEVICE_TYPE_ANDROID_CODE,
  DEVICE_TYPE_IOS_CODE,
  LOCATION_ALL_SELECTED_TEXT,
  LOCATION_SELECT_UNCHECK_TEXT,
  CURRENT_LOCATION_TEXT,
  NOTIFICATION_TYPE_TEXT,
  NOTIFICATION_TYPE_1_TEXT,
  NOTIFICATION_TYPE_2_TEXT,
  NOTIFICATION_TYPE_3_TEXT,
  NOTIFICATION_TYPE_4_TEXT,
  NOTIFICATION_TYPE_5_TEXT,
  NOTIFICATION_TYPE_1_CODE,
  NOTIFICATION_TYPE_2_CODE,
  NOTIFICATION_TYPE_3_CODE,
  NOTIFICATION_TYPE_4_CODE,
  NOTIFICATION_TYPE_5_CODE,
  IS_DEBUG_TEXT,
  IS_DEBUG_ON_TEXT,
  IS_DEBUG_OFF_TEXT,
  IS_DEBUG_ON_CODE,
  IS_DEBUG_OFF_CODE,
  URL_TEXT,
} from '../../../util/Const';
import getBytes from '../../../util/StringUtil';
// #endregion import

/**
 * タイトルコンポーネント
 * @param title
 * @param setTitle
 */
export const Title = (props: any) => {
  const { title, setTitle } = props;
  const onChange = (text: string) => {
    setTitle(text);
  };

  return (
    <>
      <dt>{TITLE_TEXT}</dt>
      <dd>
        <input
          type="text"
          value={title}
          className={getBytes(title) > 256 ? 'border_red' : ''}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            onChange(e.target.value)
          }
        />
      </dd>
    </>
  );
};

/**
 * メッセージコンポーネント
 * @param message
 * @param setMessage
 */
export const Message = (props: any) => {
  const { message, setMessage } = props;

  const onChange = (e: any) => {
    setMessage(e.target.value);
  };

  return (
    <>
      <dt>{MESSAGE_TEXT}</dt>
      <dd>
        <textarea
          value={message}
          className={getBytes(message) > 1024 ? 'border_red' : ''}
          onChange={onChange}
        />
      </dd>
    </>
  );
};

/**
 * デバイスタイプコンポーネント
 * @param device
 * @param setDevice
 */
export const DeviceType = (props: any) => {
  const { device, setDevice } = props;

  const onChange = (e: any) => {
    switch (e.target.value) {
      case DEVICE_TYPE_ANDROID_CODE:
        setDevice([DEVICE_TYPE_ANDROID_CODE]);
        break;
      case DEVICE_TYPE_IOS_CODE:
        setDevice([DEVICE_TYPE_IOS_CODE]);
        break;
      default:
        setDevice([DEVICE_TYPE_ANDROID_CODE, DEVICE_TYPE_IOS_CODE]);
        break;
    }
  };

  return (
    <>
      <dt>{DEVICE_TYPE_TEXT}</dt>
      <dd>
        <label>
          <input
            type="radio"
            id="all_device"
            value="all"
            checked={device.length === 2}
            onChange={onChange}
          />
          <label htmlFor="all_device" className="radio">
            {DEVICE_TYPE_ALL_TEXT}
          </label>
        </label>
        <label>
          <input
            type="radio"
            id="device_android"
            value={DEVICE_TYPE_ANDROID_CODE}
            checked={
              (device as string[]).length === 1 &&
              (device as string[]).includes(DEVICE_TYPE_ANDROID_CODE)
            }
            onChange={onChange}
          />
          <label htmlFor="device_android" className="radio">
            {DEVICE_TYPE_ANDROID_TEXT}
          </label>
        </label>
        <label>
          <input
            type="radio"
            id="device_ios"
            value={DEVICE_TYPE_IOS_CODE}
            checked={
              (device as string[]).length === 1 &&
              (device as string[]).includes(DEVICE_TYPE_IOS_CODE)
            }
            onChange={onChange}
          />
          <label htmlFor="device_ios" className="radio">
            {DEVICE_TYPE_IOS_TEXT}
          </label>
        </label>
      </dd>
    </>
  );
};

/**
 * 対象地域コンポーネント
 * @param municipality
 * @param currentLocation
 * @param setCurrentLocation
 */
export const CurrentLocation = (props: any) => {
  const { municipality, currentLocation, setCurrentLocation } = props;

  // #region 選択済み対象地域
  const selectedItems = currentLocation.map(
    (location: MunicipalityCode, i: Number) => {
      // 都道府県
      const selectedPref = municipality.find(
        (item: Municipality) =>
          item.region_code === location.region_code &&
          item.prefecture_code === location.prefecture_code
      );
      let name = '';
      // 市区町村
      let selectedCity: City | undefined;
      if (location.city_code !== 0 && selectedPref !== undefined) {
        selectedCity = selectedPref.cities.find(
          (item: City) => item.city_code === location.city_code
        );
        name += selectedCity ? selectedCity.city_name : '';
      }
      // 村域以下
      if (selectedCity && location.village_code !== 0) {
        const selectedVillage = selectedCity.villages.find(
          (item: Village) => item.village_code === location.village_code
        );
        name += selectedVillage ? selectedVillage.village_name : '';
      }
      if (name === '' && currentLocation.length === 1) {
        name = LOCATION_ALL_SELECTED_TEXT;
        // return null;
      }
      return (
        <span
          key={`${location.region_code},${location.prefecture_code},${location.city_code},${location.village_code}`}
        >
          {Number(i) > 0 ? '/' : null}
          {name}
        </span>
      );
    }
  );
  // #endregion 選択済み対象地域

  // #region  市区町村
  const citySelectPref = '10,1';
  const [checkedCity, setCheckedCity] =
    useState<MunicipalityCode[]>(currentLocation);

  const changeAll = () => {
    const selected: MunicipalityCode[] = [];
    const checked: MunicipalityCode[] = [];
    // 全て解除
    // 選択済み対象地域の更新
    setCurrentLocation(selected);
    // チェックボックスの更新
    setCheckedCity(checked);
  };

  // 市区町村 都道府県
  const onChangeCheckedCity = (e: any) => {
    const selected: MunicipalityCode[] = [];
    const checked: MunicipalityCode[] = [];
    // 更新しない選択済み対象地域
    currentLocation.forEach((item: MunicipalityCode) => {
      if (
        `${item.region_code},${item.prefecture_code},${item.city_code},${item.village_code}` !==
        e.target.value
      ) {
        selected.push(item);
      }
    });
    // 更新しないチェックボックス
    checkedCity.forEach((item: MunicipalityCode) => {
      if (
        `${item.region_code},${item.prefecture_code},${item.city_code},${item.village_code}` !==
        e.target.value
      ) {
        checked.push(item);
      }
    });
    const value: string[] = e.target.value.split(',');
    if (e.target.checked) {
      // 更新する選択済み対象地域
      selected.push({
        region_code: Number(value[0]),
        prefecture_code: Number(value[1]),
        city_code: Number(value[2]),
        village_code: Number(value[3]),
      });
      // 更新するチェックボックス
      checked.push({
        region_code: Number(value[0]),
        prefecture_code: Number(value[1]),
        city_code: Number(value[2]),
        village_code: Number(value[3]),
      });
    }
    // 選択済み対象地域の更新
    setCurrentLocation(selected);
    // チェックボックスの更新
    setCheckedCity(checked);
  };

  const CityCheckboxItems = municipality
    .find(
      (pref: Municipality) =>
        citySelectPref === `${pref.region_code},${pref.prefecture_code}`
    )
    ?.cities.map((city: City, i: Number) => {
      const prefCode: string[] = citySelectPref.split(',');
      if (city.villages !== undefined) {
        return city.villages.map((village: Village, j: number) => {
          return (
            <label key={`${city.city_code}_${village.village_code}`}>
              <input
                type="checkbox"
                id={`current_location_city_${i}_${j}`}
                value={`${prefCode[0]},${prefCode[1]},${city.city_code},${village.village_code}`}
                checked={checkedCity.some(
                  (checked) =>
                    checked.region_code === Number(prefCode[0]) &&
                    checked.prefecture_code === Number(prefCode[1]) &&
                    checked.city_code === city.city_code &&
                    checked.village_code === village.village_code
                )}
                onChange={onChangeCheckedCity}
              />
              <label
                htmlFor={`current_location_city_${i}_${j}`}
                className="checkbox location"
              >
                {city.city_name + village.village_name}
              </label>
            </label>
          );
        });
      }
      return (
        <label key={`${city.city_code}`}>
          <input
            type="checkbox"
            id={`current_location_city_${i}`}
            value={`${prefCode[0]},${prefCode[1]},${city.city_code},0`}
            checked={checkedCity.some(
              (checked) =>
                checked.region_code === Number(prefCode[0]) &&
                checked.prefecture_code === Number(prefCode[1]) &&
                checked.city_code === city.city_code &&
                checked.village_code === 0
            )}
            onChange={onChangeCheckedCity}
          />
          <label
            htmlFor={`current_location_city_${i}`}
            className="checkbox location"
          >
            {city.city_name}
          </label>
        </label>
      );
    });
  // #endregion 市区町村

  // #region return
  return (
    <>
      <dt>{CURRENT_LOCATION_TEXT}</dt>
      <dd>
        <dl className="box location current_location_selected">
          {currentLocation.length > 0
            ? selectedItems
            : LOCATION_ALL_SELECTED_TEXT}
        </dl>
        <dl className="box location">
          <input
            type="button"
            className="location up"
            value={LOCATION_SELECT_UNCHECK_TEXT}
            onClick={changeAll}
          />
          <dd className="location" />
          <dd className="location">{CityCheckboxItems}</dd>
        </dl>
      </dd>
    </>
  );
  // #endregion return
};

/**
 * URLコンポーネント
 * @param url
 * @param setUrl
 */
export const Url = (props: any) => {
  const { url, setUrl } = props;

  const onChange = (e: any) => {
    setUrl(e.target.value);
  };

  return (
    <>
      <dt>{URL_TEXT}</dt>
      <dd>
        <input
          type="text"
          value={url}
          className={getBytes(url) > 1024 ? 'border_red' : ''}
          onChange={onChange}
        />
      </dd>
    </>
  );
};

/**
 * 送信種別コンポーネント
 * @param type
 * @param setType
 */
export const NotificationType = (props: any) => {
  const { type, setType } = props;

  const onChange = (e: any) => {
    setType(Number(e.target.value));
  };

  return (
    <>
      <dt>{NOTIFICATION_TYPE_TEXT}</dt>
      <dd>
        {sessionStorage.getItem('city') === '0' &&
        sessionStorage.getItem('village') === '0' ? (
          <label>
            <input
              type="radio"
              id="notification_type_5"
              value={NOTIFICATION_TYPE_5_CODE}
              checked={type === NOTIFICATION_TYPE_5_CODE}
              onChange={onChange}
            />
            <label htmlFor="notification_type_5" className="radio">
              {NOTIFICATION_TYPE_5_TEXT}
            </label>
          </label>
        ) : null}
        {sessionStorage.getItem('city') === '0' &&
        sessionStorage.getItem('village') !== '0' ? null : (
          <label>
            <input
              type="radio"
              id="notification_type_1"
              value={NOTIFICATION_TYPE_1_CODE}
              checked={type === NOTIFICATION_TYPE_1_CODE}
              onChange={onChange}
            />
            <label htmlFor="notification_type_1" className="radio">
              {NOTIFICATION_TYPE_1_TEXT}
            </label>
          </label>
        )}
        {sessionStorage.getItem('city') === '0' &&
        sessionStorage.getItem('village') === '2' ? null : (
          <label>
            <input
              type="radio"
              id="notification_type_2"
              value={NOTIFICATION_TYPE_2_CODE}
              checked={type === NOTIFICATION_TYPE_2_CODE}
              onChange={onChange}
            />
            <label htmlFor="notification_type_2" className="radio">
              {NOTIFICATION_TYPE_2_TEXT}
            </label>
          </label>
        )}
        {sessionStorage.getItem('city') === '0' &&
        sessionStorage.getItem('village') !== '1' ? (
          <label>
            <input
              type="radio"
              id="notification_type_3"
              value={NOTIFICATION_TYPE_3_CODE}
              checked={type === NOTIFICATION_TYPE_3_CODE}
              onChange={onChange}
            />
            <label htmlFor="notification_type_3" className="radio">
              {NOTIFICATION_TYPE_3_TEXT}
            </label>
          </label>
        ) : null}
        {sessionStorage.getItem('city') === '0' &&
        sessionStorage.getItem('village') === '0' ? (
          <label>
            <input
              type="radio"
              id="notification_type_4"
              value={NOTIFICATION_TYPE_4_CODE}
              checked={type === NOTIFICATION_TYPE_4_CODE}
              onChange={onChange}
            />
            <label htmlFor="notification_type_4" className="radio">
              {NOTIFICATION_TYPE_4_TEXT}
            </label>
          </label>
        ) : null}
      </dd>
    </>
  );
};

/**
 * テスト通知コンポーネント
 * @param isDebug
 * @param setIsDebug
 */
export const IsDebug = (props: any) => {
  const { isDebug, setIsDebug } = props;

  const onChange = (e: any) => {
    setIsDebug(Number(e.target.value));
  };

  return (
    <>
      <dt>{IS_DEBUG_TEXT}</dt>
      <dd>
        <label>
          <input
            type="radio"
            id="is_debug_on"
            value={IS_DEBUG_ON_CODE}
            checked={isDebug === IS_DEBUG_ON_CODE}
            onChange={onChange}
          />
          <label htmlFor="is_debug_on" className="radio">
            {IS_DEBUG_ON_TEXT}
          </label>
        </label>
        <label>
          <input
            type="radio"
            id="is_debug_off"
            value={IS_DEBUG_OFF_CODE}
            checked={isDebug === IS_DEBUG_OFF_CODE}
            onChange={onChange}
          />
          <label htmlFor="is_debug_off" className="radio">
            {IS_DEBUG_OFF_TEXT}
          </label>
        </label>
      </dd>
    </>
  );
};
